import { Flex } from '@chakra-ui/react';
import { reasonsTexts } from './ReasonsTexts';
import { ReasonsItem } from './ReasonsItem';

export const ReasonsFlexBox = () => (
  <Flex
    justify="space-between"
    flexDirection={{ base: 'column', md: 'row' }}
    pt={8}
  >
    {reasonsTexts.map(reason => (
      <ReasonsItem
        key={reason.title}
        icon={reason.icon}
        title={reason.title}
        body={reason.body}
      />
    ))}
  </Flex>
);
